function isImage(filename) {
    return /\.(jpe?g|png|gif|bmp|svg|webp)$/i.test(filename);
}

// FileInput component
export default function (name) {
    let root, input, preview;

    return {
        initialized: false,
        file: '',
        url: '',
        showPreview: false,
        basename: '',

        get name() {
            return name;
        },

        get basename() {
            return this.file.split('/').pop();
        },

        get loaded() {
            return this.file.length > 0;
        },

        get isImage() {
            return isImage(this.file);
        },

        init() {
            root = this.$root;
            input = this.$refs.input;
            preview = this.$refs.preview;

            this.$nextTick(() => {
                if (!this.initialized) {
                    this.initialized = true;
                    this.file = root.dataset.file;
                    this.url = root.dataset.url;
                }

                this.showPreview = Boolean(parseInt(root.dataset.showPreview, 10));
            });

            this.$watch('file', (value) => {
                this.$refs.oldInput.value = value;

                if (root._x_model) {
                    root._x_model.set(value);
                }
            });

            this.$watch('url', (value) => (preview.src = value));

            input.addEventListener('change', (event) => {
                if (event.target.files.length === 0) return;

                const file = event.target.files[0];
                this.file = file.name;

                if (!this.showPreview) return;

                if (!isImage(file.name)) {
                    preview.src = 'data:image/png;base64,';
                    return;
                }

                const fileReader = new FileReader();

                fileReader.addEventListener('load', (event) => {
                    preview.src = event.target.result;
                });

                fileReader.readAsDataURL(file);
            });
        },

        select() {
            input.click();
        },

        remove() {
            this.resetData();
            input.dispatchEvent(new Event('change', { bubbles: true }));

            Helper.dispatchCustomEvent('revalidate', { attribute: name });
        },

        resetData(file = '', url = '') {
            const normalize = (value) => ([null, undefined].includes(value) ? '' : value);

            input.value = '';
            this.initialized = true;
            this.file = normalize(file);
            this.url = normalize(url);
        },
    };
}
